import { useState, useEffect, useCallback } from "react";
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { apiCallUnrecognizedAi } from "../../../Core/Apicall";
import CommonShimmer from "../../Common/CommonShimmer/CommonShimmer";
import EmptyData from "../../Common/EmptyData/EmptyData";
import CommonPagination from "../../Common/CommonPagination/CommonPagination";
import { useNavigate } from "react-router-dom";
import moment from "moment";

interface UnrecognizedType {
    _id?: string;
    message: string;
    profileImagePath: string;
    fullName: string;
}

function Unrecognized() {
    const [data, setData] = useState<UnrecognizedType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);

    const totalPages = Math.ceil(totalItems / rowsPerPage)

    const fetchVibes = useCallback(async (pageNumber = page, limit = rowsPerPage) => {
        setLoading(true);
        try {
            const payload = { offset: pageNumber, limit };
            const response = await apiCallUnrecognizedAi(payload);

            if (response?.data) {
                setData(response.data.items || response.data);
                setTotalItems(response?.totalCount || 0);
            } else {
                setData([]);
            }
        } catch (err) {
            setData([]);
        } finally {
            setLoading(false);
        }
    }, [page, rowsPerPage]);

    useEffect(() => {
        fetchVibes(page, rowsPerPage);
    }, [page, rowsPerPage, fetchVibes]);

    const navigate = useNavigate();



    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    return (
        <Box style={{ paddingBottom: "20px" }}>
            <Paper
                className="bg-white mt-3 border-20 scroll-bar"
                sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    height: "auto",
                    position: "relative",
                }}
            >
                <TableContainer className="scroll-bar" sx={{ height: "auto" }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>User Name</TableCell>
                                <TableCell>Profile</TableCell>
                                <TableCell>Message</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        {loading === false &&
                            <TableBody>
                                {data.map((item: any) => (
                                    <TableRow hover key={item._id} onClick={() =>
                                        navigate("/admin/UserDetails", { state: { user: item } })
                                    }
                                        style={{ cursor: "pointer" }}
                                    >
                                        <TableCell>{item?.fullName || "-"}</TableCell>
                                        <TableCell>
                                            {item?.profileImagePath ? (
                                                <img
                                                    src={item.profileImagePath}
                                                    alt="profile"
                                                    style={{
                                                        width: 40,
                                                        height: 40,
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </TableCell>
                                        <TableCell>{item.message || "-"}</TableCell>
                                        <TableCell>{moment(item.createdAt).format("DD-MMM-YYYY hh:mm a") || "-"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>}
                    </Table>
                    {loading && (
                        <div style={{ padding: "10px 10px" }}>
                            <CommonShimmer />
                        </div>
                    )}
                </TableContainer>
                <CommonPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalItems={totalItems}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={(value) => {
                        setRowsPerPage(value)
                        setPage(1)
                    }}
                />
                {!loading && <EmptyData data={data} />}
            </Paper>
        </Box>
    );
}

export default Unrecognized;
